import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { styled } from '@zenbusiness/zui/styles';

export const Image = styled(SharedAsset)(({ theme }) => ({
  borderRadius: theme.shape.rounded.lg,
}));
